module.exports = __webpack_public_path__ + "static/15-c172c7ce17c15fa82783fc815ae1d7d2.gif";